import type { FaireProductEntity } from "../../entity_types/product";

export const p_c5dm7n9wjr: FaireProductEntity = {
  token: "p_c5dm7n9wjr",
  type: "product",
  name: "18k Gold PVD Stainless Steel Pearl Cross Bracelet (Kids)",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/66f9afdf7e02b503eb451dcfc3813c42c6e1ee7f39ed7c066b95edef3d18acc7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/04b79ea905e0171603dab2ec3452eb81828eb564eb5c8fafca2949f5f6d056dd.jpeg",
    "https://cdn.faire.com/fastly/4fda1c6b2243aee71ccca67591675f77869d7f1831c1230963dbdbdf4ec32597.jpeg",
    "https://cdn.faire.com/fastly/f9fe6e38e77cc04b0c5eae8b106b8f8edf5e58fcfc3c07172c6145b3e531009f.jpeg",
    "https://cdn.faire.com/fastly/ea5f18f62d5a9760305fb5e92512fbf8742c83b38459dba159fb505350225a31.jpeg",
    "https://cdn.faire.com/fastly/d6d606b10921e9590ba1ed30aa18eae32024eeabd969b850e834d1d0b019217e.jpeg",
    "https://cdn.faire.com/fastly/0a899b2e5d6eeed55d60793a76baa1af7bd7f8d3a365283c38f13466e1b665ef.jpeg",
  ],
  priceDollars: 4.91,
  description:
    "The sweetest Easter gift for little ones — this faux pearl and gold cross bracelet is a keepsake they'll treasure for years.\n\nFeaturing luminous faux pearls and a dainty 18K gold PVD stainless steel cross charm, this stretch bracelet is gentle on young wrists and easy to slip on and off. Thoughtfully designed for faith-filled occasions, it's the perfect addition to an Easter basket, First Communion gift, or any meaningful milestone moment — a delicate reminder of devotion made just for them.\n\n✦ 100% Waterproof, Non-tarnish, Hypoallergenic\n✦ Quality That Lasts\n✦ Designed for All Skin Types\n✦ Perfect for Every Budget\n\nIdeal for retailers curating Easter gift collections, First Communion assortments, or meaningful milestone jewelry — this kids' pearl cross bracelet blends faith, sentiment, and everyday wearability in one giftable design.\n\nSize/Dimension: 4mm \n\nWhy PVD?\nWe use Physical Vapor Deposition (PVD) to coat 18K Gold over 316L stainless steel. This process ensures a high-quality, non-tarnish finish that resists wear & will never turn skin green — ideal for jewelry to be worn every day.\n\nSame day shipping from Destin, FL before 3PM CST.\nQuestions? Contact us at [redacted-email]",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:28.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
